import { Controller } from "@hotwired/stimulus"
import { fill, money, number, percent, read } from "../../lib/format"

// Units and revenue at which contribution covers the fixed costs.
export default class extends Controller {
  static targets = ["fixed", "price", "variable", "units", "revenue", "contribution"]
  static values = { messages: Object }

  connect() { this.compute() }

  compute() {
    const fixed = read(this.fixedTarget)
    const price = read(this.priceTarget)
    const contribution = price - read(this.variableTarget)

    if (contribution <= 0 || price <= 0) {
      this.unitsTarget.textContent = this.messagesValue.no_break_even
      this.unitsTarget.classList.add("warn")
      this.revenueTarget.textContent = "—"
      this.contributionTarget.innerHTML = `${money(contribution)} <small>${this.messagesValue.per_unit}</small>`
      return
    }

    const units = Math.ceil(fixed / contribution)
    this.unitsTarget.classList.remove("warn")
    this.unitsTarget.textContent = number(units)
    this.revenueTarget.textContent = money(units * price)
    this.contributionTarget.innerHTML = `${money(contribution)} <small>${fill(this.messagesValue.of_price, { percent: percent(contribution / price) })}</small>`
  }
}
